import AxiosAPI from '../../utils/AxiosAPI';

export const handleChangeCustomerStatusOpe = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/status`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// DEPRECATED
export const handleChangeCustomerTypeOpe = (formData, customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/role`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleDisable2faOpe = (customerId, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${customerId}/disable-2fa`)
            .put()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleUpdateCustomerOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers/${formData.Id}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export const handleCreateCustomerOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleImportCustomer = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/customers-import/import-xlsx`)
            .post(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName || '');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
